export default "__VITE_ASSET__D5Z9UZdd__"